export class EmployeeCreateModel {
    Name: string;
    Surname: string;
    NIF: string;
    Gender: string;
    SS: string;
    CompanyId: number;
    BirthDate: any;
    Position: string;
    Telephone1: string;
    Telephone2: string;
    Movil: string;
    Telephone3: string;
    Telephone4: string;
    Direction1: string;
    Province1: string;
    City1: string;
    PostalCode1: string;
    Direction2: string;
    Province2: string;
    City2: string;
    PostalCode2: string;
    Observation: string;
    HiringDate: any;
    ContractEndDate: any;
    EmployeeRef: string;
    Urgent: boolean;
    Jornada: number;
    Attribute1: string;
    Attribute2: string;
    Attribute3: string;
    Attribute4: string;
    Attribute5: string;
    Attribute6: string;
    Attribute7: string;
    Attribute8: string;
    Attribute9: string;
    Attribute10: string;
    Attribute11: string;
    Attribute12: string;
}